function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Parent Ramen class Component
 * Use for all common features for components
 * Supports: scroll event
 *
 * To use:
 * Call bindScroll from child class and pass through onscroll function
 */

import { debounce } from '@ramenjs/utilitybelt';

var RamenComponent = function RamenComponent() {
  var _this = this;

  _classCallCheck(this, RamenComponent);

  this.bindScroll = function () {
    window.addEventListener('scroll', _this.handleScroll);
  };

  this.unBindScroll = function () {
    window.removeEventListener('scroll', _this.handleScroll);
  };

  this.bindResize = function () {
    window.addEventListener('resize', _this.handleResize);
  };

  this.unBindResize = function () {
    window.removeEventListener('resize', _this.handleResize);
  };

  this.handleScroll = debounce(function () {
    _this.onScroll();
  }, 100);
  this.handleResize = debounce(function () {
    _this.onResize();
  }, 100);

  this.init = function () {
    console.log('RamenComponent: Missing init method in class. Add init method to your child class to handle the module initialisation');
  };

  this.onScroll = function () {
    console.log('RamenComponent: Missing onScroll method in class. Add onScroll method to your child class to handle the scroll event');
  };

  this.onResize = function () {
    console.log('RamenComponent: Missing onResize method in class. Add onResize method to your child class to handle the resize event');
  };
};

export default RamenComponent;